<template>
  <el-container>
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="inStockBills"
          @reset="resetHandle"
          @delete="deleteHandle"
          @select="selectHandle"
          @addOrEdit="addEditHandle">
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="入库单号">
              <el-input v-model.trim="filter.billNo" placeholder="请输入入库单号" clearable/>
            </el-form-item>
            <el-form-item label="入库类型">
              <el-select v-model="filter.inStockType" placeholder="请选择入库类型" clearable>
                <el-option label="采购入库" :value="0"/>
                <el-option label="生产入库" :value="1"/>
                <el-option label="调拨入库" :value="2"/>
                <el-option label="退回入库" :value="3"/>
                <el-option label="退料入库" :value="4"/>
                <el-option label="赠送入库" :value="5"/>
                <el-option label="借用入库" :value="6"/>
                <el-option label="盘盈入库" :value="7"/>
                <el-option label="其他入库" :value="8"/>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="filter.status" placeholder="请选择订单状态" clearable>
                <el-option label="未提交" :value="0"/>
                <el-option label="已提交" :value="1"/>
                <el-option label="已入库" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商">
              <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
            </el-form-item>
            <el-form-item label="关联单据">
              <el-input v-model.trim="filter.relBillNo" placeholder="请输入关联单据编号" clearable/>
            </el-form-item>
            <el-form-item label="制单人">
              <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
            </el-form-item>
            <!--          <el-form-item label="要求日期">-->
            <!--            <el-date-picker-->
            <!--                v-model="requireDateRange"-->
            <!--                type="daterange"-->
            <!--                range-separator="至"-->
            <!--                start-placeholder="开始时间"-->
            <!--                end-placeholder="结束时间"-->
            <!--                value-format="yyyy-MM-dd"-->
            <!--                @change="dateRangeChange('requireDateRange', 'requireDateBegin', 'requireDateEnd')"/>-->
            <!--          </el-form-item>-->
            <el-form-item label="制单日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'createDateFrom', 'createDateTo')"/>
            </el-form-item>
          </el-form>
        </template>
        <template slot="otherBtn">
          <el-button v-if="submitAuth" :disabled="!selection.length" type="primary" @click="suspend">提交</el-button>
          <el-button v-if="cancelAuth" :disabled="!selection.length" type="primary" @click="cancelSuspend">撤销
          </el-button>
          <el-button v-if="printAuth" :disabled="!selection.length" type="primary" @click="printInStockOrder">打印入库单
          </el-button>
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows">批量删除</el-button>
        </template>
      </view-table>
      <storage-order-edit ref="editPage" @save-success="loadData(1)"/>
      <print-in-stock-order-modal ref="printInStockOrder"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import PrintInStockOrderModal from "../ProductionStorage/PrintStorageOrder.vue";
  import StorageOrderEdit from "./StorageOrderEdit";

  export default {
    name: "StorageOrderList",
    components: {ViewTable, StorageOrderEdit, PrintInStockOrderModal},
    data() {
      return {
        selection: [],
        createDateRange: [],
        filter: {
          billNo: "",
          inStockType: "",
          status: "",
          supplierName: "",
          receiptDateFrom: "",
          receiptDateTo: "",
          createDateFrom: "",
          createDateTo: "",
          relBillNo: "",
          creatorName: "",
        },
        limits: {
          addAuth: this.$auth(81),
          delAuth: this.$auth(88),
          editAuth: this.$auth(86),
        },
        submitAuth: this.$auth(82),
        cancelAuth: this.$auth(83),
        printAuth: this.$auth(84),
        delAllAuth: this.$auth(85),
        detailAuth: this.$auth(87),
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 100,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        if (this.detailAuth) {
                          this.$refs.editPage.open(params.row, true);
                        }
                      },
                    },
                  },
                  params.row.billNo,
              );
            },
          },
          {
            key: "inStockTypeName",
            align: "center",
            width: 100,
          },
          {
            key: "relBillNo",
            align: "left",
            width: 160,
          },
          {
            key: "statusName",
            align: "center",
            width: 80,
          },
          {
            key: "receiptDate",
            align: "center",
            width: 160,
          },
          {
            key: "createTime",
            align: "center",
            width: 160,
          },
          {
            key: "creatorName",
            align: "center",
            width: 100,
          },
          {
            key: "note",
            align: "left",
            minWidth: 180,
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      // "filter.requireDateBegin": {
      //   handler(newVal) {
      //     if (newVal) {
      //       this.requireDateRange = [];
      //       this.requireDateRange.push(this.filter.requireDateBegin);
      //       this.requireDateRange.push(this.filter.requireDateEnd);
      //     }
      //   },
      // },
      "filter.createDateFrom": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createDateFrom);
            this.createDateRange.push(this.filter.createDateTo);
          }
        },
      },
    },
    methods: {
      //获取列表数据
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        if (row) {
          if (row.status) {
            this.$message.error("当前订单状态无法进行编辑");
            return;
          }
        }
        this.$refs.editPage.open(row);
      },

      //选择
      selectHandle(selection) {
        this.selection = selection;
      },


      //订单提交
      suspend() {
        const arr = this.selection.filter((item) => item.status);
        if (arr.length) {
          this.$confirm("请选择未提交的入库订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          let ids = [];
          this.selection.forEach((item) => {
            ids.push(item.pkid);
          });
          this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "inStockBills/submit", ids).then(() => {
              this.loadData(1);
              this.selection = [];
              this.$message.success("提交成功");
            });
          });
        }
      },

      //撤销方法
      cancelSuspend() {
        const arr = this.selection.filter((item) => item.status !== 1);
        if (arr.length) {
          this.$confirm("请选择已提交的入库订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          let ids = [];
          this.selection.forEach((item) => {
            ids.push(item.pkid);
          });
          this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "inStockBills/cancel", ids).then(() => {
              this.loadData(1);
              this.selection = [];
              this.$message.success("撤销成功");
            });
          });
        }
      },

      //打印入库单
      printInStockOrder() {
        const arr = this.selection.filter((item) => item.status !== 1);
        if (arr.length) {
          this.$confirm("请选择已提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$refs.printInStockOrder.open(ids);
      },

      // 单个删除
      deleteHandle(row) {
        if (row.status) {
          this.$message.error("当前订单状态无法删除");
          return;
        }
        this.$http.delete("basic", "inStockBills", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.selection = [];
            this.$message.success("删除成功");
          }
        });
      },

      //批量删除
      deleteRows() {
        const arr = this.selection.filter((item) => item.status);
        if (arr.length) {
          this.$confirm("请选择未提交状态的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "inStockBills/deleteBatch", ids).then(() => {
            this.loadData(1);
            this.selection = [];
            this.$message.success("删除成功");
          });
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
